import axios from 'axios';
import { values } from 'lodash-es';
import Logger from '@tools/logger/logger';
import { URL_NEWSLETTER } from '@tools/routes/routes';
import TwigFormValidator from '@tools/twig-form/validator';
import { showSubmitLoader, hideSubmitLoader } from '@atoms/spinner';

export default function (formSelector, input) {
  const form = document.querySelector(formSelector);
  const inputTextContainers = form.querySelectorAll('.input-text');
  let error = form.querySelector('.error');

  const validator = new TwigFormValidator({
    formSelector,
    rules: { 'newsletter[email]': [ 'email', 'required' ] },
    messages: { 'newsletter[email]': 'email' },
    onSuccess: (event) => {
      event.preventDefault();
      const submitBtn = form.querySelector('button');
      showSubmitLoader(submitBtn);
      Logger.info('Post newsletter form to controller');

      axios.post(URL_NEWSLETTER, new FormData(form))
        .then((response) => {
          const { data } = response;
          const message = values(data.messages).join(', ');
          const labelError = '<label class="error" for="newsletter_email"></label>';

          Logger.info('Receive data from newsletter controller');
          Logger.info('Message:', message);
          Logger.debug(data);

          // Remove current error/valid label, and replace it with empty one
          form.querySelectorAll('label.error, label.valid').forEach((label) => {
            label.remove();
          });
          input.parentNode.insertAdjacentHTML('beforeend', labelError);
          error = form.querySelector('.error');

          if (!data.error) {
            form.querySelectorAll('.error, #newsletter_email').forEach((element) => {
              element.classList.add('valid');
              element.classList.remove('error');
            });
            inputTextContainers.forEach((element) => {
              element.classList.add('hidden');
            });
            submitBtn.classList.add('hidden');
            form.insertAdjacentHTML('beforeend', `<p class="success">${message}</p>`);
          } else {
            form.querySelectorAll('.error, #newsletter_email').forEach((element) => {
              element.classList.remove('valid');
              element.classList.add('error');
            });
            hideSubmitLoader(submitBtn);
          }

          if (error) {
            error.textContent = message;
          }
        });

      event.stopPropagation();

      return false;
    },
  });
  validator.init();
}
